export default "__VITE_ASSET__BZQQckl7__"